"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ControlledTimePickerKeyboardField = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var react_component_library_1 = require("@esub-engineering/react-component-library");
var react_hook_form_1 = require("react-hook-form");
exports.ControlledTimePickerKeyboardField = react_1.default.memo(function (_a) {
    var required = _a.required, control = _a.control, defaultValue = _a.defaultValue, rest = __rest(_a, ["required", "control", "defaultValue"]);
    var _b = (0, react_hook_form_1.useController)({
        name: rest.name,
        control: control,
        defaultValue: defaultValue,
    }), _c = _b.field, ref = _c.ref, inputProps = __rest(_c, ["ref"]), _d = _b.fieldState, invalid = _d.invalid, error = _d.error;
    // NOTE: error text can be set in the form with yup
    var validationProps = {
        error: invalid,
        helperText: invalid ? error === null || error === void 0 ? void 0 : error.message : undefined,
    };
    return (0, jsx_runtime_1.jsx)(react_component_library_1.TimePickerKeyboard, __assign({}, rest, inputProps, validationProps, { inputRef: ref }));
});
